
import als from 'api/als'
import common from 'config/common'

export default {
    state: {
        tags: [],
        tagsError: null,
    },
    mutations: {
        setTags(state, payload) {
            state.tags = payload
        },
        setTagsError(state, payload) {
            state.tagsError = payload
        },
    },
    actions: {
        async getTags({ commit, }) {
            try {
                const { data, } = await als.get('tags')
                commit('setTags', data || [])
                commit('setTagsError', false)
            } catch (error) {
                commit('showMessage', { text: error.errors, type: common.messageType.ERROR, })
                commit('setTagsError', error)
            }
        },
        async createTag({ commit, dispatch,}, tagObject) {
            try {
                const { data, } = await als.post('tags', tagObject)
                if (data) {
                    await dispatch('getTags')
                }
            } catch (error) {
                commit('showMessage', { text: error.errors, type: common.messageType.ERROR, })
                commit('setTagsError', error)
            }
        },
    },
    getters: {
        tags: (state) => state.tags,
        tagsError: (state) => state.tagsError,
    },
}
